/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
// import { Link } from "react-router-dom";
import Marquee from "react-easy-marquee";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import StarHalfIcon from "@mui/icons-material/StarHalf";
// import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
// Material Kit 2 React components
import * as React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { useQuery } from "@apollo/client";
import { HOME_NEWS } from "graphql/query/news";
import { Link } from "react-router-dom";

// Material Kit 2 React examples
// import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

const SliderText = styled("div")({
  fontSize: "18px",
  marginTop: "10px",
  fontWeight: 700,
  marginRight: "30px",
  color: "#FF0000",
});
function Counters() {
  const [offset] = React.useState(0);
  const [newsDatas, setNewsDatas] = React.useState([]);
  const { loading, error, data } = useQuery(HOME_NEWS, {
    variables: {
      newsFilter: {
        orderColumn: "id",
        status: true,
        limit: 100,
        offset,
        orderDirection: "desc",
      },
    },
  });
  React.useEffect(() => {
    if (loading === false) {
      if (error) {
        setNewsDatas([]);
      } else {
        setNewsDatas(data.getHomeNews.news);
      }
    }
  }, [data, loading, error]);
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container spacing={5} item xs={12} lg={12} alignItems="center">
          <Grid item xs={12} md={40} display="flex">
            <Card
              sx={{
                overflow: "hidden",
                p: 1,

                minWidth: "100%",
              }}
            >
              <MKTypography
                variant="h3"
                sx={{
                  textAlign: "center",
                  color: "rgba(10, 10, 10, 0.8)",
                  textTransform: "uppercase",
                }}
                py={1}
              >
                Announcements
                <hr className="hr-1" />
              </MKTypography>
              <CardContent>
                {newsDatas.length >= 1 ? (
                  <Marquee
                    duration={50000}
                    background="#fff"
                    height="70px"
                    axis="x"
                    align="start"
                    pauseOnHover={1}
                    reverse={1}
                  >
                    {newsDatas.map((news) => (
                      <>
                        <SliderText>
                          <StarHalfIcon />
                          &nbsp;
                          {news.title}
                          &nbsp;{" "}
                          <Link className="read-more-btn " to="/news">
                            Read More <i className="fa fa-angle-double-right" aria-hidden="true" />
                          </Link>
                          &nbsp;
                          <StarHalfIcon />
                        </SliderText>
                      </>
                    ))}
                  </Marquee>
                ) : (
                  newsDatas.map((news) => (
                    <>
                      <SliderText>
                        {news.title} <Link to="/news">...Read More</Link>
                      </SliderText>
                    </>
                  ))
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
